import { Component, Input } from '@angular/core';
import { ReservaFNRHDTO } from 'src/app/core/types';

@Component({
  selector: 'others-info-view',
  templateUrl: './others-info-view.component.html',
  styleUrls: ['./others-info-view.component.scss'],
})
export class OthersInfoViewComponent {
  @Input() fnrh: ReservaFNRHDTO = {} as ReservaFNRHDTO;

  isEmpty(value: string | number | null): boolean {
    if (value == null) return false;

    if (typeof value == 'string') {
      return value.trim().length == 0 ? false : true;
    }

    if (isNaN(value as number)) return false;

    return true;
  }
}
